// extracted by mini-css-extract-plugin
export default {"comment":"HUScJjsv","icon":"schGHvEz"};